var _ = require('underscore');

module.exports = function escapeHTML (str) {
  return _.escape(str);
};



//////////////////
// WEBPACK FOOTER
// ./~/cartodb-deep-insights.js/src/util/escape-html.js
// module id = 57
// module chunks = 2 3